import { __decorate } from "tslib";
import { css, html, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { EDITED_COLUMN_FIELD } from '../grid-pro.types';
/**
 * The AG Multiselect Editor element.
 * @public
 * @tagname %%prefix%%-multiselect-editor
 */
export class MultiselectEditor extends FoundationElement {
    init(params) {
        if (!params)
            return;
        this.params = params;
        this.selectedOptions = params.value;
        // DATASERVER does not support array type so selected options could be fetched from another resource
        if (this.params.selectedOptionsCallback) {
            this.params.selectedOptionsCallback(this.params.data).then((selectedOptions) => {
                this.selectedOptions = selectedOptions;
            });
        }
        // if value was provided as string component will assume it's in csv syntax
        if (typeof params.value === 'string') {
            this.selectedOptions = params.value.split(',');
        }
    }
    getGui() {
        return this;
    }
    destroy() { }
    refresh(params) {
        return true;
    }
    getValue() {
        return this.selectedOptions;
    }
    isPopup() {
        return true;
    }
    changeHandler(event) {
        this.selectedOptions = event.detail;
    }
    isCancelBeforeStart() {
        return !!this.params.data[EDITED_COLUMN_FIELD];
    }
}
__decorate([
    observable
], MultiselectEditor.prototype, "params", void 0);
__decorate([
    observable
], MultiselectEditor.prototype, "selectedOptions", void 0);
/**
 * The AG Select Renderer Styles.
 * @public
 */
export const agMultiselectEditorStyles = css ``;
/**
 * Get a Design System prefixed Select template.
 * @param designSystem - The design system prefix to use. Defaults to 'foundation'.
 * @returns A Select component template prefixed with the correct design system.
 * @public
 */
export const getMultiselectEditorTemplate = (designSystem = 'foundation') => html `
  <${designSystem}-multiselect
    style="width: 100%"
    ?async=${(x) => x.params.async}
    :selectedOptions=${(x) => x.selectedOptions || []}
    @selectionChange=${(x, c) => x.changeHandler(c.event)}
  >
    <multiselect-datasource
      resourceName=${(x) => x.params.allOptionsResourceName}
      value-field=${(x) => x.params.valueField}
      label-field=${(x) => x.params.labelField}
      :datasourceConfig=${(x) => x.params.datasourceOptions}
    ></multiselect-datasource>
  </${designSystem}-multiselect>
`;
/**
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-multiselect-editor\>
 */
export const foundationMultiselectEditor = MultiselectEditor.compose({
    baseName: 'multiselect-editor',
    styles: agMultiselectEditorStyles,
    template: getMultiselectEditorTemplate(),
});
